export default "__VITE_ASSET__BcbCmOAh__"